import React from "react";

import { mapDOM } from "commons/utils/utils";

export type AttributesType = {
    href?: string;
    target?: string;
    [x: string]: any;
};

export type HtmlType = {
    type: string;
    attributes: AttributesType;
    content: Array<HtmlType | string>;
};

type PropsType = {
    elements: Array<HtmlType | string>;
};

const validTags: Array<string> = [
    "div",
    "p",
    "ul",
    "ol",
    "li",
    "a",
    "strong",
    "b",
    "em",
    "ins",
    "i",
];

function RenderContent({ elements }: PropsType) {
    return (
        <React.Fragment>
            {elements.map((element, i) => {
                if (typeof element === "string") {
                    return <React.Fragment key={i}>{element}</React.Fragment>;
                } else {
                    if (validTags.indexOf(element.type) !== -1) {
                        const CustomTag = element.type as keyof JSX.IntrinsicElements;

                        if ("dangerouslySetInnerHTML" in element.attributes) {
                            delete element.attributes.dangerouslySetInnerHTML;
                        }

                        return (
                            <CustomTag key={i} {...element.attributes}>
                                <RenderContent elements={element.content} />
                            </CustomTag>
                        );
                    }

                    if (element.type === "br") {
                        return <br key={i} />;
                    }
                }

                return null;
            })}

            {elements.length === 0 && <br />}
        </React.Fragment>
    );
}

function HtmlWrapper({ htmlString }: { htmlString: string }) {
    const domMapped = React.useMemo(() => {
        return [mapDOM(htmlString) ?? ""];
    }, [htmlString]);

    return (
        <div className={"html-viewer-container"}>
            <RenderContent elements={domMapped} />
        </div>
    );
}

export default HtmlWrapper;
